import type { SxProps } from "@mui/material"

const container: SxProps = {
  width: "100%"
}

const labelContainer = {
  display: "flex",
  flexDirection: "row"
}

const inputStyle = (size?: "small" | "medium") => ({
  width: "100%",
  height: size === "small" ? "30px" : "44px",
  paddingLeft: size === "small" ? "45px" : "65px"
})
export default { labelContainer, container, inputStyle }
